// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.label[data-v-35888a67] {\n\tfont-size: 16px;\n\theight:18px;\n}\n.value[data-v-35888a67] {\n\tcolor: var(--main-gray-5);\n\tfont-size: 14px;\n\theight: 17px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
